import { SelectOption } from '@frontend/basic-forms';
import { useAppSelector } from '@frontend/common';
import { IoTEnumClient } from '@frontend/iot/api';
import { IoTTrigger, IoTTriggerName } from '@frontend/iot/types';
import { fetchGeneralWorkflowTriggers, workflowSharedStore } from '@frontend/workflow/redux';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { IoTTriggerSelectProps } from './iot-trigger-select.component';

interface ViewProps {
    options: SelectOption<IoTTriggerName>[];
}

const useIoTTriggerSelect = (props: IoTTriggerSelectProps): ViewProps => {
    const [triggers, changeTriggers] = useState<string[]>([]);
    const workflowSharedState = useAppSelector(useSelector, workflowSharedStore);

    useEffect(() => {
        props.dispatch && props.dispatch(fetchGeneralWorkflowTriggers());
        IoTEnumClient.fetchIoTTriggers().then(changeTriggers);
    }, []);

    const options = useMemo(() => {
        if (!triggers || !workflowSharedState.generalWorkflowTriggers) return [];
        return [...triggers, ...workflowSharedState.generalWorkflowTriggers].map((trigger) => {
            const found = IoTTrigger.ALL.find((t) => t.value === trigger);
            if (found) return { value: found.value, label: found.value, display: found.displayName };
            else
                return {
                    value: trigger,
                    label: trigger.replace(/_/g, ' ')
                };
        });
    }, [triggers, workflowSharedState.generalWorkflowTriggers]);

    return { options };
};

export default useIoTTriggerSelect;
